<section *ngIf="propiedades"
    class="padding-30px-tb xs-padding-60px-tb blog-style1 bg-light-deep-yellow  border-none header-margin-top-medium"
    id="">
    <div class="container">
        <!-- title -->
        <div class="row text-detail">
            <div class="col-md-4 margin-five-bottom">
                <!-- title -->
                <h2 class="title alt-font title-extra-large font-weight-700 text-dark-brown margin-one-bottom">Propiedad
                    {{propiedades.numero_referencia}} <small> - ID {{ propiedades.id }} <br
                            class="visible-xs-block"></small></h2>
                <div class="text-large font-weight-700 text-dark-brown padding-seven">
                    <h3 class="font-weight-600">Localidad: {{propiedades.localidad}}</h3>
                    <br>
                    <h3 class="font-weight-600">Departamento: {{propiedades.departamento.descripcion}}</h3>
                    <br>
                    <h3 class="font-weight-600">Zona: {{propiedades.zona}}</h3>
                    <br>
                    <h3 class="font-weight-600">Descripcion: {{propiedades.descripcion}}</h3>
                </div>
                <!-- end  title -->
            </div>
            <div class="col-md-8 margin-five-bottom">
                <div class="margin-two-bottom">
                    <!--<tabset [justified]="true">
            <tab heading="Fotos" id="tab1">-->
                    <div class="row">
                        <owl-carousel #owlElement [carouselClasses]="['owl-carousel', 
            'owl-theme', 
            'owl-light-pagination', 
            'white-pagination', 
            'testimonial-style3']" [items]="propiedades.imagenes" [options]="{ navigation: false,
              responsiveClass: true,
              items: 1,
              itemsDesktop: [1200, 1],
              itemsTablet: [800, 1],
              itemsMobile: [700, 1]}">
                            <div class="item" *ngFor="let imagen of propiedades.imagenes">
                                <img src="{{imagen.url}}" data-img-size="(W)800px X (H)650px" alt="">
                            </div>
                        </owl-carousel>
                    </div>
                    <!-- </tab>
          </tabset>-->
                </div>
            </div>
        </div>
    </div>
    <app-contacto incrustado=true nombre="Propiedad 1"></app-contacto>
</section>
<section class="padding-50px-tb bg-light-deep-yellow  xs-padding-60px-tb feature-style-31 border-none" id="">
    <div class="separator-line1 width-80 bg-dark-brown center-col  margin-five-bottom sm-margin-ten-bottom"></div>
    <div class="container">
        <div class="row">
            <!-- feature box -->
            <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-fifteen-bottom">
                <div class=" display-table width-100">
                    <a routerLink="/como-funciona" routerLinkActive="active">
                        <div class="text-dark-brown icon-style margin-seven-right display-table-cell-vertical-middle">
                            <span class="fas fa-info-circle title-extra-large-2 "></span></div>
                        <div class="display-table-cell-vertical-middle ">
                            <span class="text-medium text-medium-gray ">Información</span>
                            <h3 class="text-large alt-font text-dark-gray ">Como funciona</h3>
                        </div>
                    </a>
                </div>
            </div>
            <!-- end feature box -->
            <!-- feature box -->
            <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-fifteen-bottom">
                <div class=" display-table width-100">
                    <a routerLink="/condiciones-subasta" routerLinkActive="active">
                        <div class="text-dark-brown icon-style margin-seven-right display-table-cell-vertical-middle">
                            <span class="fas fa-gavel title-extra-large-2 "></span></div>
                        <div class="display-table-cell-vertical-middle ">
                            <span class="text-medium text-medium-gray ">Participar de subastas</span>
                            <h3 class="text-large alt-font text-dark-gray ">Condiciones</h3>
                        </div>
                    </a>
                </div>
            </div>
            <!-- end feature box -->
            <!-- feature box -->
            <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-fifteen-bottom">
                <div class=" display-table width-100">
                    <a routerLink="/login" routerLinkActive="active">
                        <div class="text-dark-brown icon-style margin-seven-right display-table-cell-vertical-middle">
                            <span class="fas fa-address-card title-extra-large-2 "></span></div>
                        <div class="display-table-cell-vertical-middle ">
                            <span class="text-medium text-medium-gray ">Únase hoy mismo</span>
                            <h3 class="text-large alt-font text-dark-gray ">Registro</h3>
                        </div>
                    </a>
                </div>
            </div>
            <!-- end feature box -->
            <!-- feature box -->
            <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-fifteen-bottom">
                <div class=" display-table width-100">
                    <a routerLink="/login" routerLinkActive="active">
                        <div class="text-dark-brown icon-style margin-seven-right display-table-cell-vertical-middle">
                            <span class="fas fa-sign-in-alt title-extra-large-2 "></span></div>
                        <div class="display-table-cell-vertical-middle ">
                            <span class="text-medium text-medium-gray ">¿Ya está registrado?</span>
                            <h3 class="text-large alt-font text-dark-gray ">Ingresar</h3>
                        </div>
                    </a>
                </div>
            </div>
            <!-- end feature box -->
        </div>
    </div>
</section>
